import { BUTTONS, SizeSmallLeftIcon, SizeSmallCenterIcon, SizeSmallRightIcon } from 'wix-rich-content-plugin-commons';
import { MAX_WIDTH, MAX_HEIGHT_INPUT, MAX_ALIGNMENT_WIDTH, SRC_TYPE_HTML, SRC_TYPE_URL, MIN_WIDTH, MAX_HEIGHT, MIN_HEIGHT } from '../defaults.js';
import { HtmlEditPanelDraft } from './HtmlEditPanelDraft.js';
import { translate } from 'wix-rich-content-common';
import EditIcon from '../icons/EditIcon.js';
import 'react';
import './HtmlEditPanel.js';
import 'prop-types';
import 'classnames';
import 'wix-rich-content-ui-components';
import 'lodash';
import '../AdsenseTitle.js';
import '../style-inject.es-746bb8ed.js';

const getAlignmentButtonPropsFn = (getEditorBounds) => ({ componentData }) => {
  var _a;
  const editorBounds = getEditorBounds == null ? void 0 : getEditorBounds();
  const maxAlignmentWidth = editorBounds ? editorBounds.width - 1 : MAX_ALIGNMENT_WIDTH;
  return {
    disabled: (((_a = componentData == null ? void 0 : componentData.config) == null ? void 0 : _a.width) || 0) > maxAlignmentWidth
  };
};
const TOOLTIP_TEXT_BY_SRC_TYPE = {
  [SRC_TYPE_HTML]: "HtmlPlugin_EditHtml_Tooltip",
  [SRC_TYPE_URL]: "HtmlPlugin_EditUrl_Tooltip"
};
const createInlineButtons = ({
  settings = {},
  getEditorBounds
}) => {
  var _a;
  const {
    maxWidth,
    minWidth = MIN_WIDTH,
    maxHeight = MAX_HEIGHT,
    minHeight = MIN_HEIGHT
  } = settings;
  const icons = ((_a = settings == null ? void 0 : settings.toolbar) == null ? void 0 : _a.icons) || {};
  return [
    {
      type: BUTTONS.INLINE_PANEL,
      keyName: "edit",
      panelContent: translate()(HtmlEditPanelDraft),
      icon: icons.edit || EditIcon,
      mapComponentDataToButtonProps: ({ src, srcType }) => ({
        tooltipTextKey: src ? TOOLTIP_TEXT_BY_SRC_TYPE[srcType] : "HtmlPlugin_EditEmpty_Tooltip"
      })
    },
    { type: BUTTONS.SEPARATOR, keyName: "separator1" },
    {
      type: BUTTONS.WIDTH,
      getEditorBounds,
      keyName: "width",
      min: minWidth,
      mapStoreDataToPanelProps: () => {
        const bounds = getEditorBounds();
        if (bounds && bounds.width) {
          return { max: maxWidth ? Math.min(maxWidth, bounds.width) : bounds.width };
        } else {
          return { max: maxWidth || MAX_WIDTH };
        }
      }
    },
    {
      type: BUTTONS.HEIGHT,
      keyName: "height",
      min: minHeight,
      max: maxHeight,
      inputMax: MAX_HEIGHT_INPUT
    },
    { type: BUTTONS.SEPARATOR, keyName: "separator2" },
    {
      type: BUTTONS.TEXT_ALIGN_LEFT,
      keyName: "alignLeft",
      icon: icons.alignLeft || SizeSmallLeftIcon,
      mapStoreDataToButtonProps: getAlignmentButtonPropsFn(getEditorBounds)
    },
    {
      type: BUTTONS.TEXT_ALIGN_CENTER,
      keyName: "alignCenter",
      icon: icons.alignCenter || SizeSmallCenterIcon
    },
    {
      type: BUTTONS.TEXT_ALIGN_RIGHT,
      keyName: "alignRight",
      icon: icons.alignRight || SizeSmallRightIcon,
      mapStoreDataToButtonProps: getAlignmentButtonPropsFn(getEditorBounds)
    },
    { type: BUTTONS.SEPARATOR, keyName: "separator3" },
    { type: BUTTONS.DELETE, keyName: "delete", mobile: true }
  ];
};

export { createInlineButtons as default };
//# sourceMappingURL=inline-buttons.js.map
